import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { QuartileColor } from "./quartileColor";
import { HexCode, HexCodeDTO } from "../types/hexCode";

export interface QuartileColorWithHexCodesDTO {
  quartileColor: QuartileColor.QuartileColorDTO;
  primitiveQuartileColor: HexCodeDTO;
  defaultSingleSelectQuartileColor?: HexCodeDTO | null;
}

export class QuartileColorWithHexCodes {
  readonly isQuartileColorWithHexCodesQuartileColorWithHexCodes: boolean = true;

  readonly quartileColor: QuartileColor.QuartileColor;
  readonly primitiveQuartileColor: HexCode;
  readonly defaultSingleSelectQuartileColor: HexCode | null;


  constructor(
  quartileColor: QuartileColor.QuartileColor, 
  primitiveQuartileColor: HexCode, 
  defaultSingleSelectQuartileColor: HexCode | null = null
  ) {
    this.quartileColor = quartileColor;
    this.primitiveQuartileColor = primitiveQuartileColor;
    this.defaultSingleSelectQuartileColor = defaultSingleSelectQuartileColor;
  }

  static fromDTO(dto: QuartileColorWithHexCodesDTO): QuartileColorWithHexCodes {
    const quartileColor = QuartileColor.fromDTO(getObject(dto, "quartileColor", InvalidQuartileColorWithHexCodesQuartileColorError));
    const primitiveQuartileColor = HexCode.fromDTO(getObject(dto, "primitiveQuartileColor", InvalidQuartileColorWithHexCodesPrimitiveQuartileColorError));
    let defaultSingleSelectQuartileColor = getOptionalObject(dto, "defaultSingleSelectQuartileColor");
    if(defaultSingleSelectQuartileColor !== undefined && defaultSingleSelectQuartileColor !== null) {
      defaultSingleSelectQuartileColor = HexCode.fromDTO(getObject(dto, "defaultSingleSelectQuartileColor", InvalidQuartileColorWithHexCodesDefaultSingleSelectQuartileColorError));
    }
    return new QuartileColorWithHexCodes(
      quartileColor,
      primitiveQuartileColor,
      defaultSingleSelectQuartileColor
    );
  }

  toDTO(): QuartileColorWithHexCodesDTO {
    const dto: QuartileColorWithHexCodesDTO = {
        quartileColor: QuartileColor.toDTO(this.quartileColor),
        primitiveQuartileColor: this.primitiveQuartileColor.toDTO(),
    };
    if (this.defaultSingleSelectQuartileColor !== undefined && this.defaultSingleSelectQuartileColor !== null){
      dto.defaultSingleSelectQuartileColor = this.defaultSingleSelectQuartileColor.toDTO();
    }
    return dto;
  }
  }

QuartileColorWithHexCodes.prototype.toString = function toString(): string {
  return `QuartileColorWithHexCodes(quartileColor='${this.quartileColor}',primitiveQuartileColor='${this.primitiveQuartileColor}',defaultSingleSelectQuartileColor='${this.defaultSingleSelectQuartileColor}')`;
};

export class InvalidQuartileColorWithHexCodesError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorWithHexCodesError";
  }
}
export class InvalidQuartileColorWithHexCodesQuartileColorError extends InvalidQuartileColorWithHexCodesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorWithHexCodesQuartileColorError";
  }
}

export class InvalidQuartileColorWithHexCodesPrimitiveQuartileColorError extends InvalidQuartileColorWithHexCodesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorWithHexCodesPrimitiveQuartileColorError";
  }
}

export class InvalidQuartileColorWithHexCodesDefaultSingleSelectQuartileColorError extends InvalidQuartileColorWithHexCodesError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuartileColorWithHexCodesDefaultSingleSelectQuartileColorError";
  }
}
